import styled from 'styled-components'

export const AlertsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 24px;
`
